<template>
    <div>
        <div class="search-box">
            <p>学号/英文名/中文名：</p>
            <a-input class="input-box" v-model="searchFrom.studentName"/>
            <p>导师：</p>
            <a-input class="input-box" v-model="searchFrom.guideTeacherName"/>
            <p>学习截至日期：</p>
            <a-date-picker class="input-box" v-model="searchFrom.endDate" @change="(date, dateString)=>{searchFrom.endDate=dateString+' 23:59:59'}"/>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>
            <!-- <a-button type="primary" icon="download" class="right-btn" >导出Excel</a-button> -->
            <!-- <a-button type="primary" icon="import" class="right-btn" >批量导入</a-button> -->
            <a-button type="primary" icon="plus" class="right-btn" @click="$refs.info.showDrawer('新增','')">新增</a-button>
        </div>
        <a-table 
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ x: '250%' }"
            bordered>
            <template slot="genderCode" slot-scope="text,record">
                <a-select class="show-input" v-model="record.genderCode" disabled>
                    <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
                </a-select>
            </template>
            <template slot="id" slot-scope="text">
                <a class="action-btn" @click="$refs.info.showDrawer('查看',text)">详情</a>
                <a-divider type="vertical" />
                <a class="action-btn" @click="$refs.info.showDrawer('编辑',text)">编辑</a>
                <a-divider type="vertical" />
                <a-popconfirm
                    title="确定删除？"
                    ok-text="确定"
                    cancel-text="取消"
                    @confirm="remove(text)"
                >
                    <a class="action-btn">删除</a>
                </a-popconfirm>
            </template>
        </a-table>
        <!-- <p class="table-tips">更新截至日期：{{lastTime}}</p> -->
        <info ref="info"></info>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del } from '@/baseAPI/international/student'
    import Info from './modules/studentInfo'
    const columns = [
        {
            title: '序号',
            dataIndex: 'id',
            align:'center',
            width:70,
            fixed: 'left',
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '学号',
            dataIndex: 'studentNo',
            align:'center',
            width:150,
            fixed: 'left',
        },
        {
            title: '英文名',
            dataIndex: 'studentEnglishName',
            align:'center',
            width:300,
            fixed: 'left',
            ellipsis: true,
        },
        {
            title: '中文名',
            dataIndex: 'studentChName',
            align:'center',
            width:150,
            fixed: 'left',
        },
        {
            title: '国籍',
            dataIndex: 'nationalityName',
            align:'center'
        },
        {
            title: '性别',
            dataIndex: 'genderCode',
            scopedSlots: { customRender: 'genderCode' },
            align:'center'
        },
        {
            title: '出生日期',
            dataIndex: 'birthday',
            align:'center'
        },
        {
            title: '护照号码',
            dataIndex: 'passportId',
            align:'center'
        },
        {
            title: '学习截止日期',
            dataIndex: 'learningDeadline',
            align:'center'
        },
        {
            title: '所在院校',
            dataIndex: 'collegeName',
            align:'center'
        },
        {
            title: '专业学院',
            dataIndex: 'majorDepartmentName',
            align:'center',
        },
        {
            title: '专业名称',
            dataIndex: 'majorName',
            align:'center'
        },
        {
            title: '学生类别',
            dataIndex: 'studentTypeName',
            align:'center',
        },
        {
            title: '导师',
            dataIndex: 'guideTeacherName',
            align:'center'
        },
        {
            title: '经费来源',
            dataIndex: 'fundsSource',
            ellipsis: true,
            align:'center'
        },
        {
            title: '在沪居住地址',
            dataIndex: 'shanghaiResidence',
            align:'center',
            ellipsis: true,
        },
        {
            title: '手机号码',
            dataIndex: 'phoneNumber',
            align:'center'
        },
        {
            title: '学籍状态',
            dataIndex: 'studentStatusName',
            align:'center',
        },
        {
            title: '操作',
            dataIndex: 'id',
            scopedSlots: { customRender: 'id' },
            width:200,
            fixed: 'right',
        }

    ];
    export default {
        name: 'teacher',
        components: {
            Info
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 10,
                    current: 0,
                    total:0,
                },
                searchFrom:{
                    size: '',
                    current: '',
                    studentName:'',
                    guideTeacherName:'',
                    endDate:'',
                },
                xmlbArr:[],
                xmjbArr:[],
                kcsxArr:[],
                lastTime:'',
                xbArr:[],
            }
        },
        mounted () {
            getDicts({dataCode:'XB',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
                console.log(this.xbArr)
            })
            this.fetch()
        },
        methods:{
            handleTableChange(pagination){
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;
                    this.loading = false;
                })
            },
            handSearch(value){
                if(value!=''){
                    this.searchFrom.guideTeacherName=value
                }
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除留学生信息成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },

        }
    }
</script>
<style scoped>
    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 24px;
    }
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 13rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .table-tips{
        margin-top: -48px;
        line-height: 32px;
        padding-left: 15px;
        color: #aaa;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }

</style>
